import { useState } from 'react';

import CookieBannerGC from '@skyscanner-internal/global-components/cookie-banner';
import ConsentBanner from '@skyscanner-internal/global-components/unstable__consent-banner';
import logger from 'saddlebag-logger';

import withErrorBoundary from '../ErrorBoundary/WithErrorBoundary';

import type { CookieBannerSSRProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CookieBanner';

const isBrowser = globalThis.window !== undefined;

const CookieBanner = (props: CookieBannerSSRProps) => {
  const [cookieBannerAccepted, setCookieBannerAccepted] = useState(false);

  if (cookieBannerAccepted) {
    return null;
  }

  const sharedProps = {
    ...props,
    onPolicyAcceptClick: () => setCookieBannerAccepted(true),
    logger: isBrowser ? logger : props.logger,
  };

  return props.enableKetchCMP ? (
    <ConsentBanner {...sharedProps} />
  ) : (
    <CookieBannerGC {...sharedProps} />
  );
};

const CookieBannerWithErrorBoundary = withErrorBoundary(
  CookieBanner,
  'cookie-banner',
);

export default CookieBannerWithErrorBoundary;
